import { LatLngExpression } from 'leaflet'
import { IPositionGeometry, IPositionGeometryCoordinate, IPositionType } from 'src/generated-types'
import { geometryDefaultColors } from 'src/screens/localities/components/map/constraints'

export const isClosedGeometryType = (type: IPositionType): boolean => type === IPositionType.Polygon

export const isGeometryPositionType = (type: IPositionType): boolean =>
  type === IPositionType.Polygon || type === IPositionType.ElectricityLine

export const minimumGeometryCoordinates = (type: IPositionType): number => (isClosedGeometryType(type) ? 3 : 2)

export const getDefaultGeometryColor = (type: IPositionType): string =>
  isClosedGeometryType(type) ? geometryDefaultColors.recaptureZone : geometryDefaultColors.powerLine

export const getGeometryColor = (geometry: IPositionGeometry | undefined, type: IPositionType): string =>
  geometry?.color ?? getDefaultGeometryColor(type)

export const getOrderedGeometryCoordinates = (geometry: IPositionGeometry | undefined): IPositionGeometryCoordinate[] =>
  [...(geometry?.coordinates ?? [])].sort((a, b) => a.order - b.order)

export const getGeometryLatLngs = (geometry: IPositionGeometry | undefined): LatLngExpression[] =>
  getOrderedGeometryCoordinates(geometry).map(p => [p.latitude, p.longitude] as LatLngExpression)

export const hasRenderableGeometry = (geometry: IPositionGeometry | undefined, type: IPositionType): boolean =>
  (geometry?.coordinates?.length ?? 0) >= minimumGeometryCoordinates(type)

export const toGeometryCoordinates = (latLngs: Array<{ lat: number; lng: number }>): IPositionGeometryCoordinate[] =>
  latLngs.map((p, index) => ({ order: index, latitude: p.lat, longitude: p.lng }))
